<template>
  <el-dialog
    class="recycle_dialog"
    :visible.sync="visible"
    :show="show"
    :close-on-click-modal="false"
    title="回收站"
    @close="closeDialog"
    @open="openDialog"
  >
    <div class="r_tips">问卷在删除前会显示剩余天数（最长 30 天），之后将永久删除。</div>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :header-cell-style="tableStyle"
      @selection-change="selectCheckbox"
    >
      <el-table-column
        type="selection"
        align="center"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="left"
        header-align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        width="170"
      >
      </el-table-column>
      <el-table-column
        prop="deleted_at"
        label="删除时间"
        align="center"
        width="170"
      >
      </el-table-column>
      <el-table-column
        label="剩余时间"
        align="center"
        width="80"
      >
        <template #default="{row}">
          {{remainDays(row.deleted_at)}}
        </template>
      </el-table-column>
    </el-table>
    <div class="dialog_footer">
      <el-pagination
        background
        :current-page="pagination.current_page"
        :page-size="pagination.per_page"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
      <div class="btns">
        <el-button
          size="small"
          @click="visible=false"
        >取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="restoreSurvey"
        >恢复</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getRecycleList, restoreSurvey } from "@/api/survey";
import moment from "moment";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.show,
      tableStyle: {
        color: "#6F6F6F",
        "background-color": "#F5F7F9",
        "border-color": "#E3E8EE"
      },
      tableData: [],
      pagination: {},
      checkbox: []
    };
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  },
  methods: {
    openDialog() {
      this.tableData = [];
      this.getRecycleList();
    },
    closeDialog() {
      this.$emit("update:show", false);
    },
    restoreSurvey() {
      if (this.checkbox.length === 0) {
        this.$message({
          type: "warning",
          center: true,
          message: "请选择您要恢复的问卷",
          duration: 1500
        });
        return;
      }
      restoreSurvey({
        ids: this.checkbox
      }).then(() => {
        this.$message({
          type: "success",
          center: true,
          message: "恢复成功",
          duration: 1500
        });
        this.getRecycleList();
        this.$emit("refresh");
      });
    },
    getRecycleList() {
      getRecycleList({
        page: this.pagination.current_page
      }).then(res => {
        this.tableData = res.data;
        this.pagination = res.meta.pagination;
      });
    },
    remainDays(date) {
      let _30 = moment(date)
        .add(30, "days")
        .format("YYYY-MM-DD HH:mm:ss"); // 删除日期的30天后的时间
      let h = moment(_30).diff(moment(), "hours"); // 当前时间距离删除日期还有多少小时
      if (h > 24) {
        return ((h / 24) | 0) + " 天";
      } else {
        return h + " 小时";
      }
    },
    selectCheckbox(selection) {
      this.checkbox = [];
      selection.forEach(item => {
        this.checkbox.push(item.id);
      });
    },
    handleCurrentChange(currentPage) {
      this.$set(this.pagination, "current_page", currentPage);
      this.getRecycleList();
    }
  }
};
</script>

<style lang="less" scoped>
.recycle_dialog {
  .el-dialog {
    margin: 10vh auto 20px !important;
  }

  .el-dialog__header {
    position: relative;
  }

  .r_tips {
    position: absolute;
    top: 20.5px;
    left: 100px;
    color: #909399;
  }

  .el-dialog__body {
    padding: 0 20px;

    .el-table {
      th,
      td {
        padding: 7px 0;
      }
    }
  }

  .dialog_footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
  }
}
</style>
